export interface ITemplateButton {
  type: "QUICK_REPLY" | string;
  text: string;
}

export interface ITemplateVariable {
  key: string;
  label: string;
  example?: string;
}

export interface ITemplateComponentExample {
  body_text?: string[][];
  body_text_named_params?:
    | {
        param_name: string;
        example: string;
      }[]
    | null;
}

export interface ITemplateComponent {
  type: "HEADER" | "BODY" | "FOOTER" | "BUTTONS";
  format: "TEXT" | null;
  text: string | null;
  example: ITemplateComponentExample | null;
  buttons: ITemplateButton[] | null;
}

export interface ITemplate {
  id: string;
  name: string;
  language: string;
  status: "APPROVED" | "PENDING" | "REJECTED";
  category: string;
  sub_category: string | null;
  previous_category: string | null;
  parameter_format: "POSITIONAL" | "NAMED";
  components: ITemplateComponent[];
}

export interface ITemplateResponse {
  data: ITemplate[];
  paging?: {
    cursors?: {
      before?: string;
      after?: string;
    };
  };
}

export const getTemplateStatusStyle = (status: string) => {
  switch (status) {
    case "APPROVED":
      return {
        bg: "bg-soft-primary",
        text: "text-primary",
        labelClass: "text-success",
        label: "Aprovado",
      };
    case "PENDING":
      return {
        bg: "bg-soft-warning",
        text: "text-warning",
        labelClass: "text-warning",
        label: "Pendente",
      };
    case "REJECTED":
      return {
        bg: "bg-soft-danger",
        text: "text-danger",
        labelClass: "text-danger",
        label: "Rejeitado",
      };
    default:
      return {
        bg: "bg-soft-secondary",
        text: "text-muted",
        labelClass: "text-muted",
        label: status,
      };
  }
};
